// File: services/video.js
import { toast } from "react-toastify";

const url = `${process.env.REACT_APP_BASEURL}/api/admin/plan`;

// Get video list
export const GetPlanListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getall" }),
    });

    if (!response.ok) throw new Error("Failed to fetch plan list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
export const getCategories = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getcategories" }),
    });

    if (!response.ok) throw new Error("Failed to fetch plan list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const getPlanTypes = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "getplantypes" }),
    });

    if (!response.ok) throw new Error("Failed to fetch plan list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

// Delete video by ID
export const handleDeletePlan = async (planId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this plan?")) {
    try {
      const payload = {
        action: "delete",
        data: {
          _id: planId
        },
      };
  
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.success) toast.success("Plan deleted successfully");
      else toast.warning("Delete called, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

// Add or edit video
export const submitPlanApi = async (planData) => {
  console.log("Submitting plan data:", planData); // 👈 DEBUG
  try {
   const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(planData),
    });

    const result = await response.json();

    if (result.success || response.status === 200) {
      // toast.success(
      //   planData._id
      //     ? "Plan updated successfully"
      //     : "Plan added successfully"
      // );
      return result;
    } else {
      toast.error(result.message || "Failed to save plan");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the plan");
    return null;
  }
};

// Get single video by ID
export const getPlanByIdApi = async (id) => {
  try {

    const payload = {
      action: "getById",
      data: {
        _id: id
      },
    };

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    console.log("Get by ID result:", result);
    if (result.success) return result;
    else toast.error("Failed to load plan");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
